import React, { useState } from "react";
// kendo
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { orderBy } from "@progress/kendo-data-query";
import moment from "moment";
// css
import "./table.css";

const DepotTable = ({ data, actionDropdownClicked, onSortBy, hideDeleteOption }) => {
  const initialDataState = {
    skip: 0,
    take: 10,
    dir: "asc",
  };
  
  const initialSort = [
    {
      field: "updated_on",
      dir: "asc",
    },
  ];
      const [page, setPage] = useState(initialDataState);
  const [sort, setSort] = useState(initialSort);
  // const [orderBy, setOrderBy] = useState(true);
  const [pageSizeValue, setPageSizeValue] = React.useState();
  const options = ["View Details"];
  if (!hideDeleteOption) {
    options.push("Delete");
  }
  const pageChange = (event) => {
    const targetEvent = event.targetEvent;
    const take = targetEvent.value === "All" ? data.length : event.page.take;
    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take,
    });
  };
  const sortChange = (event) => {
    // console.log("sort change- ",event.sort);
    // setSort(event.sort);
    // console.log("sort- ",sort)
    // for (let i in event.sort)
    // {
    //   if (event.sort[i].dir == "desc"){
    //     setOrderBy(false);        
    //   }
    //   else if (event.sort[i].dir == "asc"){
    //     setOrderBy(true);        
    //   }
    //   if (event.sort[i].field == "created_on"){
    //     setSortBy("created_on"); 
    //   }
    //   else if(event.sort[i].field == "updated_on"){
    //     setSortBy("updated_on");
    //   }
    //   console.log("sortby-",sortBy,"orderby-",orderBy);
    //   onSortBy(sortBy,orderBy);
    // }    
  };
  const customDateCell = (props) => {
    if (props.dataItem[props.field] !== "") {
      return (
        <td>
          {moment(props.dataItem[props.field]).format("DD MMM YYYY, hh:mm A")}
        </td>
      );
    }
    return <td>{props.dataItem[props.field]}</td>;
  };

  return (
    <div className="tbody-content">
      {data && (
        <Grid
          style={{
            // height: "420px",
          }}
          data={orderBy(data.slice(page.skip, page.take + page.skip), sort)}
          // data={data.slice(page.skip, page.take + page.skip)}
          skip={page.skip}
          take={page.take}
          total={data.length}
          pageable={{
            buttonCount: 4,
            pageSizes: [5, 10, 15, 25, 35, 45, 55, 65, 75, 85, 100],
            pageSizeValue: pageSizeValue,
          }}
          onPageChange={pageChange}
          sortable={true}
          sort={sort}
          onSortChange={(e) => {
            setSort(e.sort);
          }}
          // sortable={{allowUnsort:false}}
          // sort={sort}
          // onSortChange={sortChange}
          // onSortChange={(e) => {
          //   setSort(e.sort);
          // }}
          className="telephone-table"
        >
          <GridColumn title={"Depot/ Sub Depot Name"} field={"depot"} width={250}/>
          <GridColumn title={"Acronym"} field={"acronym"}/>
          <GridColumn title={"Parent Depot"} field={"parent_depot"}/>
          <GridColumn title={"Depot Color"} field={"depot_color"}/>
          <GridColumn title={"Added By"} field={"created_by.name"} />
          <GridColumn key={5} title={"Updated By"} field={"updated_by.name"}/>
          <GridColumn title={"Updated On"} field={"updated_on"} cell={customDateCell} sortable={true}/>
          <GridColumn
            width={220}
            key={8}
            title={"Action"}
            cell={(props) => (
              <td>
                <DropDownList
                  data={options}
                  defaultValue={"Action"}
                  onChange={(e) => actionDropdownClicked(e, props)}
                  style={{
                    fontSize: "15px",
                    width: "120px",
                    height: "48px",
                    backgroundColor:"#EB6E1F",
                    color:"white",
                    textAlign:"center",
                    borderRadius:"8px"
                  }}
                />
              </td>
            )}
          />
        </Grid>
      )}
    </div>
  );
};

export default DepotTable;